import React, { useState, useEffect, useContext } from 'react';
import { Link, useLocation, useNavigate, Outlet } from "react-router-dom";
import systemContext from '../_context/systemContext';
import { useMediaQuery } from '@mui/material';
import { 
  FiDollarSign, FiMenu, FiLogOut, FiHome, FiChevronLeft, FiClock, FiSettings, FiEdit
} from 'react-icons/fi';
import { useSystem } from '../_context/useSystem';
import { useAuth } from "../_auth/AuthContext";
import Swal from "sweetalert2";

const Home = () => {
  const { user, isAuthenticated, logout, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const system = useSystem();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const isMobile = useMediaQuery("(max-width: 768px)");
  const SystemContext = useContext(systemContext);
  const usuarioFirmado = SystemContext.getUser();
  // Perfil 1 : Administrador
  // Perfil 2 : Owner, planeacion de ventas
  // Perfil 3 : Usuario Solo lectura
  let idPerfil = usuarioFirmado.idPerfil;
  let Perfil = usuarioFirmado.perfil;

  /* Protección MSAL */
  useEffect(() => {
    if (!loading && !isAuthenticated) {
      navigate("/login", { replace: true });
    }
  }, [loading, isAuthenticated, navigate]);

  /* 📱 Sidebar móvil */
  useEffect(() => {
    if (isMobile) setSidebarOpen(false);
  }, [isMobile]);

  if (loading) return null; // 🔥 evita render prematuro

  const navigateTo = (route) => {
    if (route !== "#") {
      navigate("/" + route);
      if (isMobile) setSidebarOpen(false);
    }
  };

  const handleLogout = () => {
    Swal.fire({
      title: "Cerrar sesión",
      text: "¿Desea cerrar la sesión del portal?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        logout();
      }
    });
  };

  const allMenuItems = [
    { title: "Inicio", route: "", icon: <FiHome />, perfiles: [1, 2, 3] },
    { title: "Saldo disponible", route: "Saldo", icon: <FiDollarSign />, perfiles: [1, 2, 3] },
    //{ title: "Pendientes de autorización", route: "#", icon: <FiClock />, perfiles: [1] },
    { title: "Configuración", route: "configuracion", icon: <FiSettings />, perfiles: [1, 2] },
    { title: "Catálogos", route: "Cat", icon: <FiEdit />, perfiles: [1, 2] },
  ];
  const menuItems = allMenuItems.filter(item =>
    item.perfiles.includes(Number(idPerfil))
  );


  const isActive = (route) =>
    location.pathname === `/${route}` || (route === "" && location.pathname === "/");

  const handleMouseEnter = (item, event) => {
    if (!sidebarOpen && !isMobile) {
      const rect = event.currentTarget.getBoundingClientRect();
      setHoveredItem(item);
      setTooltipPosition({
        top: rect.top + window.scrollY + rect.height / 2,
        left: rect.right + window.scrollX + 10,
      });
    }
  };

  const handleMouseLeave = () => setHoveredItem(null);

  /* Datos usuario (MSAL + sistema) */
  const displayName =
    system?.getUser?.()?.nombre ||
    user?.name ||
    user?.username || user?.perfil
    //"Usuario";

  return (
    <div className="modern-app">
      {/* Header */}
      <header className="modern-header">
        <div className="header-left">
          <button className="menu-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
            {sidebarOpen ? <FiChevronLeft /> : <FiMenu />}
          </button>

          <Link to="/" className="logo-container">
            <img src="/images/logo.png" alt="Qualtia" className="logo" />
            <span className="app-name">Portal venta sin cargo</span>
          </Link>
        </div>

        <div className="header-right">
          <span className="welcome-text">{displayName}</span>
          <button className="logout-btn" onClick={handleLogout}>
            <FiLogOut /> Salir
          </button>
        </div>
      </header>

      {/* Sidebar */}
      <div className={`modern-sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
        <nav className="sidebar-nav">
          {menuItems.map((item, index) => (
            <button
              key={index}
              className={`nav-item ${isActive(item.route) ? 'active' : ''}`}
              onClick={() => navigateTo(item.route)}
              onMouseEnter={(e) => handleMouseEnter(item, e)}
              onMouseLeave={handleMouseLeave}
            >
              <span className="item-icon">{item.icon}</span>
              <span className="item-title">{item.title}</span>
            </button>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">{getInitials(displayName)}</div>
            <div className="user-details">
              <span className="user-name">{displayName}</span>
              <span className="user-role">{Perfil}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Tooltip */}
      {!sidebarOpen && !isMobile && hoveredItem && (
        <div
          className="tooltip-item show"
          style={{
            top: tooltipPosition.top,
            left: tooltipPosition.left,
            transform: "translateY(-50%)",
          }}
        >
          {hoveredItem.title}
        </div>
      )}

      {/* Main */}
      <main className={`modern-main ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <Outlet />
      </main>

      {/* Overlay móvil */}
      {isMobile && sidebarOpen && (
        <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />
      )}
    </div>
  );
};

export default Home;

/* Util */
const getInitials = (name) => {
  if (!name) return "U";
  return name
    .trim()
    .split(/\s+/)
    .map(w => w[0])
    .join("")
    .substring(0, 2)
    .toUpperCase();
};
